import { AccountDetails } from 'clientServerShared/types/account';
import { AppProviders } from 'projects/legacyClient/src/appProviders';
import { FC } from 'react';
import { HeapCategory } from 'clientServerShared/types/eventTracking';
import { LegacyBreedSummaryCard } from '@embark/shared-components/src/breedSummary/legacyBreedSummaryCard';
import ReactDOM from 'react-dom';
import { getPetNumFromQueryString } from 'projects/legacyClient/src/react/pet/getPetNumFromQueryString';
import { handleGraphQLError } from '@embark/shared-components/src/services/errors/handleGraphQLError';
import { useAppSelector } from 'projects/legacyClient/src/react/state/hooks';
import { useGetBreedSummaryCardDataQuery } from '@embark/shared-components/src/generated/graphql-client-types';

export function initBreedSummaryCard(): void {
  ReactDOM.render(
    <AppProviders>
      <BreedSummaryCardContainer />
    </AppProviders>,
    document.getElementById('breed-summary-card')
  );
}

const BreedSummaryCardContainer: FC = () => {
  const petNum = getPetNumFromQueryString();
  const accountDetails: AccountDetails | undefined = useAppSelector((state) => state.accountDetails);

  const { data, error } = useGetBreedSummaryCardDataQuery({
    variables: {
      petNum: petNum,
    },
  });

  if (error) {
    handleGraphQLError(error);
    return <></>;
  }

  if (!data?.me || !data.me.petByPetNum) {
    return <></>;
  }

  return (
    <LegacyBreedSummaryCard
      accountDetails={accountDetails}
      dog={data.me.petByPetNum}
      showShare={true}
      showProductType={true}
      showCareResourcesBanner={true}
      allowSupermuttCallout={true}
      heapMetadata={{ heapCategory: HeapCategory.RESULTS_BREED }}
    />
  );
};
